import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "circle-placeholder-dashed" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M17.7084 9.99996C17.7084 14.2572 14.2573 17.7083 10.0001 17.7083C5.74289 17.7083 2.29175 14.2572 2.29175 9.99996C2.29175 5.74276 5.74289 2.29163 10.0001 2.29163C14.2573 2.29163 17.7084 5.74276 17.7084 9.99996Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-dasharray": "2.5 3.33"
      })
    ], -1)
  ])))
}
export default { render: render }